import {
  IonicPage,
  NavController,
  ModalController,
  LoadingController,
  AlertController,
  ToastController,
} from "ionic-angular";
import { Component } from "@angular/core";
import { ConfigService } from './../../providers/config-service';
import { HttpService } from "./../../providers/http-service";

import { UserProvider } from "./../../providers/user/user.provider";
import { EventoProvider } from "../../providers/evento/evento.provider";
import { Evento } from "../../domain/evento";

import { User } from "./../../domain/user";
import { ParticipacaoPage } from "../participacao/participacao";

@IonicPage()
@Component({
  selector: "page-home",
  templateUrl: "home.html",
})
export class HomePage {
  public usuario: User;
  public loaded: boolean = false;

  public evento_aberto: any;
  public eventos: Array<Evento> = [];

  public eventos_abertos: any;
  public eventos_fechados: any;

  // Busca client-side
  public searchTerm: string = '';
  public searchFocused: boolean = false;
  public eventos_abertos_filtrados: any;
  public eventos_fechados_filtrados: any;

  // Paginação client-side (infinite scroll)
  public pageSize: number = 20;
  public displayedCount: number = 20;

  // Controle de seleção visual dos radio groups
  public selectedAberto: any = null;
  public selectedFechado: any = null;

  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public toastCtrl: ToastController,
    private _loading: LoadingController,
    private _alertCtrl: AlertController,
    public http: HttpService,
    private userProvider: UserProvider,
    private eventoProvider: EventoProvider,
    public configService: ConfigService
  ) {
    this.checkEventoAberto();
  }

  ionViewDidLoad() {
    let loading = this._loading.create({ content: "Resgatando seus dados..." });
    loading.present();

    this.userProvider.getUserAuth().subscribe(
      (user) => {
        this.usuario = user as User;
        this.loaded = true;
        loading.dismiss();
      },
      (error) => {
        console.log("userProvider error : " + error);
      }
    );
  }

  goParticipacao() {
    this.navCtrl.push(ParticipacaoPage, {});
  }

  fecharEvento() {
    const eventoDisplay = `${this.evento_aberto.id} - ${this.evento_aberto.acao.nome} - ${this.evento_aberto.local.nome}`;

    let alert = this._alertCtrl.create({
      title: "🔒 Fechar Evento",
      message: `
        <div class="alert-evento-info">${eventoDisplay}</div>
        <p class="alert-warning-danger">Ao confirmar, este evento será <strong>fechado no sistema</strong> e não poderá receber novas operações.</p>
      `,
      cssClass: "alert-close-evento",
      buttons: [
        {
          text: "Cancelar",
          role: "cancel",
        },
        {
          text: "FECHAR EVENTO",
          handler: () => {
            let load = this._loading.create({ content: "Fechando evento..." });
            load.present();

            this.evento_aberto.status = "F";
            this.eventoProvider.update(this.evento_aberto).then((success) => {
              localStorage.removeItem("evento_aberto");
              load.dismiss();
              this.reload("Evento fechado!");
            });
          },
        },
      ],
    });
    alert.present();
  }

  setEvento(id, grupo: 'aberto' | 'fechado') {
    // Limpa seleção do outro grupo
    if (grupo === 'aberto') {
      this.selectedFechado = null;
    } else {
      this.selectedAberto = null;
    }

    let evento = this.eventos.find((evento) => evento.id == id);
    const isEventoAberto = evento.status === "C";
    const eventoNome = evento.acao.nome + " (" + evento.local.nome + ")";

    // UX diferenciada por tipo de ação
    // Formato igual à lista: ID - Ação - Local
    const eventoDisplay = `${evento.id} - ${evento.acao.nome} - ${evento.local.nome}`;
    let alertConfig: any;

    if (isEventoAberto) {
      // SELECIONAR evento já aberto (apenas localStorage)
      alertConfig = {
        title: "☑️ Selecionar Evento",
        message: `
          <div class="alert-evento-info">${eventoDisplay}</div>
          <p class="alert-hint">Este evento já está aberto.<br>Você irá selecioná-lo para trabalhar.</p>
        `,
        cssClass: "alert-select-evento",
        buttons: [
          {
            text: "Cancelar",
            role: "cancel",
            handler: () => {
              this.selectedAberto = null;
            }
          },
          {
            text: "SELECIONAR",
            cssClass: "btn-select",
            handler: () => {
              localStorage.setItem("evento_aberto", JSON.stringify(evento));
              this.reload("Evento selecionado!");
            },
          },
        ],
      };
    } else {
      // ABRIR evento fechado (altera servidor + localStorage)
      alertConfig = {
        title: "🔓 Abrir Evento",
        message: `
          <div class="alert-evento-info">${eventoDisplay}</div>
          <p class="alert-warning">Este evento está fechado.<br>Ao confirmar, ele será <strong>aberto no sistema</strong>.</p>
        `,
        cssClass: "alert-open-evento",
        buttons: [
          {
            text: "Cancelar",
            role: "cancel",
            handler: () => {
              this.selectedFechado = null;
            }
          },
          {
            text: "ABRIR EVENTO",
            cssClass: "btn-open",
            handler: () => {
              let load = this._loading.create({ content: "Abrindo evento..." });
              load.present();

              evento.status = "C";
              this.eventoProvider.update(evento).then((success) => {
                localStorage.removeItem("evento_aberto");
                localStorage.setItem("evento_aberto", JSON.stringify(evento));
                load.dismiss();
                this.reload("Evento aberto e selecionado!");
              });
            },
          },
        ],
      };
    }

    let alert = this._alertCtrl.create(alertConfig);
    alert.present();
  }

  /* Privates */

  private checkEventoAberto() {
    this.eventoProvider.getDisponiveis().subscribe((eventos) => {
      if (localStorage.getItem("evento_aberto")) {
        let ev = JSON.parse(localStorage.getItem("evento_aberto"));
        /* Checa se o evento aberto no dispositivo está mesmo aberto no servidor */
        let check = eventos.find(
          (evento) => evento.id === ev.id && evento.status === "C"
        );

        if (check !== undefined && check.hasOwnProperty("id")) {
          this.evento_aberto = ev;
        } else {
          localStorage.removeItem("evento_aberto");
          this.formatEventos(eventos);
        }
      } else {
        this.formatEventos(eventos);
      }
    });
  }

  private formatEventos(data: any[]) {
    // Preserva ordem da API (ID DESC)
    this.eventos = data.map(item => {
      const evento = new Evento();
      evento.id = item.id;
      evento.acao = item.acao;
      evento.local = item.localidade;
      evento.status = item.status;
      evento.itinerante = item.itinerante;
      evento.veiculo_obrigatorio = item.veiculo_obrigatorio;
      evento.cadastro_em_campo = item.cadastro_em_campo;
      return evento;
    });

    this.eventos_abertos = this.divideEventos("C");
    this.eventos_fechados = this.divideEventos("F");

    // Inicializa arrays filtrados
    this.eventos_abertos_filtrados = this.eventos_abertos;
    this.eventos_fechados_filtrados = this.eventos_fechados;
  }

  onSearchChange() {
    this.displayedCount = this.pageSize;

    const term = this.searchTerm.toLowerCase().trim();

    if (!term) {
      this.eventos_abertos_filtrados = this.eventos_abertos;
      this.eventos_fechados_filtrados = this.eventos_fechados;
      return;
    }

    const filterFn = (evento: Evento) => {
      const idMatch = evento.id.toString().includes(term);
      const acaoMatch = evento.acao && evento.acao.nome && evento.acao.nome.toLowerCase().includes(term);
      const localMatch = evento.local && evento.local.nome && evento.local.nome.toLowerCase().includes(term);
      return idMatch || acaoMatch || localMatch;
    };

    this.eventos_abertos_filtrados = this.eventos_abertos
      ? this.eventos_abertos.filter(filterFn)
      : false;

    this.eventos_fechados_filtrados = this.eventos_fechados
      ? this.eventos_fechados.filter(filterFn)
      : false;

    // Se filtro resultar em array vazio, mantém false para não mostrar seção
    if (this.eventos_abertos_filtrados && this.eventos_abertos_filtrados.length === 0) {
      this.eventos_abertos_filtrados = false;
    }
    if (this.eventos_fechados_filtrados && this.eventos_fechados_filtrados.length === 0) {
      this.eventos_fechados_filtrados = false;
    }
  }

  clearSearch() {
    this.searchTerm = '';
    this.onSearchChange();
  }

  get eventosAbertosPaginados() {
    if (!this.eventos_abertos_filtrados) return [];
    return this.eventos_abertos_filtrados.slice(0, this.displayedCount);
  }

  get eventosFechadosPaginados() {
    if (!this.eventos_fechados_filtrados) return [];
    const abertosCount = this.eventos_abertos_filtrados ? this.eventos_abertos_filtrados.length : 0;
    const remaining = this.displayedCount - abertosCount;
    if (remaining <= 0) return [];
    return this.eventos_fechados_filtrados.slice(0, remaining);
  }

  loadMore(event: any) {
    this.displayedCount += this.pageSize;
    event.complete();
  }

  hasMoreItems(): boolean {
    const totalAbertos = this.eventos_abertos_filtrados ? this.eventos_abertos_filtrados.length : 0;
    const totalFechados = this.eventos_fechados_filtrados ? this.eventos_fechados_filtrados.length : 0;
    return (totalAbertos + totalFechados) > this.displayedCount;
  }

  private divideEventos(status: string) {
    let eventos = this.eventos.filter((evento) => evento.status === status);
    return eventos.length > 0 ? eventos : false;
  }

  private reload(mensagem: string) {
    let toast = this.toastCtrl.create({ duration: 1500 });
    let self = this;

    toast.setMessage(mensagem);
    toast.present();
    toast.onDidDismiss(() => {
      self.navCtrl.setRoot(HomePage);
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts